/**
 * File view.js
 */
(function ($) {
    "use strict";
})(jQuery);
  